import React, { useState } from 'react';
import { SearchIcon, PlusIcon, TagIcon } from 'lucide-react';
import { MusicItem } from '../components/MusicItem';
export function Library() {
  const [selectedTab, setSelectedTab] = useState('songs');
  const [selectedTag, setSelectedTag] = useState<string | null>(null);
  // Mock data with more personalized tags
  const songs = [{
    id: '1',
    title: 'Blinding Lights',
    artist: 'The Weeknd',
    album: 'After Hours',
    cover: 'https://images.unsplash.com/photo-1611162617213-7d7a39e9b1d7?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YWZ0ZXIlMjBob3Vyc3xlbnwwfHwwfHx8MA%3D%3D',
    tags: ['summer 2025', 'road trip', 'favorite'],
    location: {
      lat: 40.7128,
      lng: -74.006
    }
  }, {
    id: '2',
    title: 'As It Was',
    artist: 'Harry Styles',
    album: "Harry's House",
    cover: 'https://images.unsplash.com/photo-1551986782-d0169b3f8fa7?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NHx8aG91c2V8ZW58MHx8MHx8fDA%3D',
    tags: ['Hannah', 'beach day', 'sunset drive'],
    location: {
      lat: 34.0522,
      lng: -118.2437
    }
  }, {
    id: '3',
    title: 'Bad Habit',
    artist: 'Steve Lacy',
    album: 'Gemini Rights',
    cover: 'https://images.unsplash.com/photo-1491841550275-ad7854e35ca6?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8Z2VtaW5pfGVufDB8fDB8fHww',
    tags: ['roadtrip France', 'with Alex', 'rainy day'],
    location: {
      lat: 37.7749,
      lng: -122.4194
    }
  }, {
    id: '4',
    title: 'Shivers',
    artist: 'Ed Sheeran',
    album: '=',
    cover: 'https://images.unsplash.com/photo-1495231916356-a86217efff12?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZXF1YWx8ZW58MHx8MHx8fDA%3D',
    tags: ['morning run', 'Central Park', 'spring 2024'],
    location: {
      lat: 51.5074,
      lng: -0.1278
    }
  }, {
    id: '5',
    title: 'Midnight Rain',
    artist: 'Taylor Swift',
    album: 'Midnights',
    cover: 'https://images.unsplash.com/photo-1536746803623-cef87080bfc8?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8bWlkbmlnaHR8ZW58MHx8MHx8fDA%3D',
    tags: ['Hannah', 'with Alex', 'summer 2025'],
    location: {
      lat: 36.1699,
      lng: -115.1398
    }
  }, {
    id: '6',
    title: 'Glimpse of Us',
    artist: 'Joji',
    album: 'Smithereens',
    cover: 'https://images.unsplash.com/photo-1581337204873-ef36aa186caa?w=800&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8c21pdGhlcmVlbnN8ZW58MHx8MHx8fDA%3D',
    tags: ['roadtrip France', 'sunset drive', 'favorite'],
    location: {
      lat: 35.6762,
      lng: 139.6503
    }
  }];
  // Extract all unique tags
  const allTags = Array.from(new Set(songs.flatMap(song => song.tags || [])));
  // Filter songs by selected tag
  const filteredSongs = selectedTag ? songs.filter(song => song.tags?.includes(selectedTag)) : songs;
  return <div className="px-4 pt-8 pb-20" data-id="element-236">
      <div className="flex justify-between items-center mb-4" data-id="element-237">
        <h1 className="text-2xl font-bold" data-id="element-238">Your Library</h1>
        <div className="flex space-x-2" data-id="element-239">
          <button className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center" data-id="element-240">
            <SearchIcon size={18} data-id="element-241" />
          </button>
          <button className="w-9 h-9 rounded-full bg-zinc-800 flex items-center justify-center" data-id="element-242">
            <PlusIcon size={18} data-id="element-243" />
          </button>
        </div>
      </div>
      {/* Tabs */}
      <div className="flex space-x-2 mb-5" data-id="element-244">
        {['songs', 'albums', 'artists', 'playlists'].map(tab => <button key={tab} className={`px-3 py-1.5 rounded-full text-sm ${selectedTab === tab ? 'bg-white text-black' : 'bg-zinc-800 text-white'}`} onClick={() => setSelectedTab(tab)} data-id="element-245">
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>)}
      </div>
      {/* Tags filter */}
      <div className="mb-6" data-id="element-246">
        <div className="flex items-center mb-2.5" data-id="element-247">
          <TagIcon size={16} className="mr-1.5 text-zinc-400" data-id="element-248" />
          <p className="text-sm text-zinc-400" data-id="element-249">Filter by tag</p>
        </div>
        <div className="flex flex-wrap gap-2" data-id="element-250">
          {allTags.map(tag => <button key={tag} className={`px-3 py-1.5 rounded-full text-sm ${selectedTag === tag ? 'bg-green-500 text-black' : 'bg-zinc-800 text-zinc-300'}`} onClick={() => {
          if (selectedTag === tag) {
            setSelectedTag(null);
          } else {
            setSelectedTag(tag);
          }
        }} data-id="element-251">
              {tag}
            </button>)}
        </div>
      </div>
      {/* Song list */}
      <div className="space-y-2" data-id="element-252">
        {filteredSongs.map(song => <MusicItem key={song.id} {...song} onPlay={() => {}} data-id="element-253" />)}
      </div>
    </div>;
}